import React from 'react'
import CognitoUserManagement from './CognitoUserManagement'
import Window from '../../../../common/Window'

class CognitoUserDetail extends CognitoUserManagement {
  componentWillMount () {
    this.loadUserDetail()
  }
  loadUserDetail () {
    const {params} = this.props.match
    const id = params.id
    this.getCognitoUser(id, (cognitoUser, logs) => {
      const userDetail = {
        enabled: cognitoUser.Enabled,
        createdDateTime: cognitoUser.UserCreateDate,
        updatedDateTime: cognitoUser.UserLastModifiedDate,
        status: cognitoUser.UserStatus,
        id: cognitoUser.Username,
        email: this.arrayGet(cognitoUser.UserAttributes, 'email'),
        name: this.arrayGet(cognitoUser.UserAttributes, 'custom:Name'),
        emailNotification: this.arrayGet(cognitoUser.UserAttributes, 'custom:emailNotification'),
        prefectures: this.arrayGet(cognitoUser.UserAttributes, 'custom:prefectures'),
        branch: this.arrayGet(cognitoUser.UserAttributes, 'custom:branch'),
        administrator: this.arrayGet(cognitoUser.UserAttributes, 'custom:administrator'),
        isMember: this.arrayGet(cognitoUser.UserAttributes, 'custom:isMember'),
        approvalFlg: this.arrayGet(cognitoUser.UserAttributes, 'custom:approvalFlg'),
        parentID: this.arrayGet(cognitoUser.UserAttributes, 'custom:ParentID')
      }
      this.setState({
        isLoaded: true,
        userDetail: userDetail,
        logs: logs
      })
    }, true)
  }
  inheritingEstimation (email) {
    if (email === '') {
      Window.alert('メールアドレスは必須です。')
      return false
    }
    this.setState({
      inheritingMessage: 'データ引き継ぎ中・・・'
    })
    const onSuccess = (res) => {
      if(!res.body || res.body.Username === '') {
        Window.alert('メールアドレスが使用されていません。')
        return false
      }
      const baseUserId = this.state.userDetail.id
      const basecompanyId = this.state.userDetail.parentID
      const userId = res.body.Username
      const companyId = this.arrayGet(res.body.Attributes, 'custom:ParentID')
      this.inheritingEstimationData(baseUserId, basecompanyId, userId, companyId, onSuccess2)
    }
    const onSuccess2 = (res) => {
      this.setState({
        inheritingMessage: ''
      })
      if(!res.body || res.body.isOK === true) {
        Window.alert('引き継ぎが完了しました。')
        return true
      }
      Window.alert('引き継ぎが失敗しました。')
      return false
    }
    
    this.getUserDataEmail(email, onSuccess)
  }
  onPageMenuClicked (name) {
    const id = this.state.userDetail.id
    let backUrl = '/admin/' + this.userRoleUrl
    let editUrl = '/admin/' + this.userRoleUrl + '/edit/' + id

    if (this.parentUserRoleUrl) {
      const {params} = this.props.match
      const parentID = params.parentID
      backUrl = '/admin/' + this.parentUserRoleUrl + '/detail/' + parentID
      editUrl = '/admin/' + this.userRoleUrl + '/edit/' + parentID + '/' + id
    }
    switch (name) {
      case 'back':
        this.props.history.push(backUrl)
        break
      case 'edit':
        this.props.history.push(editUrl)
        break
      case 'sendPasswordResetEmail':
        this.props.history.push('/admin/' + this.userRoleUrl + '/password_change/' + id)
        break
      case 'ban':
        Window.confirm('本当に削除処理を実行しますか?', () => {
          this.deleteCognitoUser(this.state.userDetail)
          Window.alert('削除処理を実行しました', () => {
            this.props.history.push(backUrl)
            Window.closeDialog()
          })
        })
        break
      case 'disable':
        Window.confirm('本当に一時無効処理を実行しますか?', () => {
          this.disableCognitoUser(this.state.userDetail)
          Window.alert('一時無効処理を実行しました', () => {
            const userDetail = this.state.userDetail
            userDetail.enabled = false
            this.setState({
              userDetail: userDetail
            })
            Window.closeDialog()
          })
        })
        break
      case 'enable':
        Window.confirm('本当に復活処理を実行しますか?', () => {
            // 退会処理
          this.enableCognitoUser(this.state.userDetail)
          Window.alert('復活処理を実行しました', () => {
            const userDetail = this.state.userDetail
            userDetail.enabled = true
            this.setState({
              userDetail: userDetail
            })
            Window.closeDialog()
          })
        })
        break
      default:
        break
    }
  }
  renderLogs () {
    if (this.state.logs.length === 0) {
      return (
        <tr><td style={{textAlign: 'center'}}>このユーザはまだ一度もログインしておりません。</td></tr>
      )
    }
    return this.state.logs.map((log, index) => {
      const dateTime = log.actionDateTime.toString()
      return (
        <tr key={index}>
          <td>{dateTime.substr(0, 4)}/{dateTime.substr(4, 2)}/{dateTime.substr(6, 2)} {dateTime.substr(8, 2)}:{dateTime.substr(10, 2)}:{dateTime.substr(12, 2)}</td>
        </tr>
      )
    })
  }
  renderUserDetail (title, nameTitle, userDetail, temporaryPassword) {
    // console.log(userDetail);
    if(this.userRoleUrl == 'admin_user') {
      return (
        <fieldset>
          <legend>{title} - 詳細</legend><br />
          {temporaryPassword && <div className="alert alert-success">ユーザーを作成しました</div>}
          <div className='control-group'><label className='control-label'>{nameTitle}</label>
            <div className='controls'>{userDetail.name}</div>
          </div>
          <div className='control-group'><label className='control-label'>メールアドレス</label>
            <div className='controls'>{userDetail.email}</div>
          </div>
          {temporaryPassword &&
            <div className='control-group'><label className='control-label'><b>パスワード</b></label>
              <div className='controls'><b>{temporaryPassword}</b></div>
            </div>
          }
          <div className='control-group'><label className='control-label'>通知受信可否</label>
            <div className='controls'>{(userDetail.emailNotification === 'true') ? '可' : '不可'}</div>
          </div>
          <div className='control-group'><label className='control-label'>アカウント有効/無効</label>
            <div className='controls'>{userDetail.enabled ? '有効' : '無効'}</div>
          </div>
          <div className='control-group'><label className='control-label'>作成日時</label>
            <div className='controls'>{this.utc2jst(userDetail.createdDateTime)}</div>
          </div>
          <div className='control-group'><label className='control-label'>最終更新日時</label>
            <div className='controls'>{this.utc2jst(userDetail.updatedDateTime)}</div>
          </div>
        </fieldset>
      )
    } else if(this.userRoleUrl == 'company_user') {
      return (
        <fieldset>
          <legend>{title} - 詳細</legend><br />
          {temporaryPassword && <div className="alert alert-success">ユーザーを作成しました</div>}
          <div className='control-group'><label className='control-label'>{nameTitle}</label>
            <div className='controls'>{userDetail.name}</div>
          </div>
          <div className='control-group'><label className='control-label'>企業ユーザーメールアドレス</label>
            <div className='controls'>{userDetail.email}</div>
          </div>
          {temporaryPassword &&
            <div className='control-group'><label className='control-label'><b>パスワード</b></label>
              <div className='controls'><b>{temporaryPassword}</b></div>
            </div>
          }
          <div className='control-group'><label className='control-label'>通知受信可否</label>
            <div className='controls'>{(userDetail.emailNotification === 'true') ? '可' : '不可'}</div>
          </div>
          <div className='control-group'><label className='control-label'>アカウント有効/無効</label>
            <div className='controls'>{userDetail.enabled ? '有効' : '無効'}</div>
          </div>
          <div className='control-group'><label className='control-label'>作成日時</label>
            <div className='controls'>{this.utc2jst(userDetail.createdDateTime)}</div>
          </div>
          <div className='control-group'><label className='control-label'>最終更新日時</label>
            <div className='controls'>{this.utc2jst(userDetail.updatedDateTime)}</div>
          </div>
        </fieldset>
      )
    } else {
      return (
        <fieldset>
          <legend>{title} - 詳細</legend><br />
          {temporaryPassword && <div className="alert alert-success">ユーザーを作成しました</div>}
          <div className='control-group'><label className='control-label'>{nameTitle}</label>
            <div className='controls'>{userDetail.name}</div>
          </div>
          <div className='control-group'><label className='control-label'>会員/会員外</label>
            <div className='controls'>
              {(userDetail.approvalFlg === 'false' && userDetail.isMember === 'false') ? '未承認' : ((userDetail.isMember === 'true' || userDetail.isMember === 'True') ? '会員' : '会員外')}
            </div>
          </div>
          <div className='control-group'><label className='control-label'>会社所在地都道府県名</label>
            <div className='controls'>{userDetail.prefectures}</div>
          </div>
          <div className='control-group'><label className='control-label'>支部名</label>
            <div className='controls'>{userDetail.branch}</div>
          </div>
          <div className='control-group'><label className='control-label'>企業管理者名</label>
            <div className='controls'>{userDetail.administrator}</div>
          </div>
          <div className='control-group'><label className='control-label'>企業管理者メールアドレス</label>
            <div className='controls'>{userDetail.email}</div>
          </div>
          {temporaryPassword &&
            <div className='control-group'><label className='control-label'><b>パスワード</b></label>
              <div className='controls'><b>{temporaryPassword}</b></div>
            </div>
          }
          <div className='control-group'><label className='control-label'>通知受信可否</label>
            <div className='controls'>{(userDetail.emailNotification === 'true') ? '可' : '不可'}</div>
          </div>
          <div className='control-group'><label className='control-label'>アカウント有効/無効</label>
            <div className='controls'>{userDetail.enabled ? '有効' : '無効'}</div>
          </div>
          <div className='control-group'><label className='control-label'>作成日時</label>
            <div className='controls'>{this.utc2jst(userDetail.createdDateTime)}</div>
          </div>
          <div className='control-group'><label className='control-label'>最終更新日時</label>
            <div className='controls'>{this.utc2jst(userDetail.updatedDateTime)}</div>
          </div>
        </fieldset>
      )
    }
  }
}

export default CognitoUserDetail



// WEBPACK FOOTER //
// ./src/admin/pages/secure/abstract/CognitoUserDetail.js